import { httpGet } from "./request/requestApi";
const controllerEndpoint = "support";
export class SliderAlerts {
    static getSliderAlerts(page, size, sortColumn = "createdDate", sortOrder = "desc", silent = true, area) {
        return httpGet(`${controllerEndpoint}/dashboard/slider-alerts?page=${page}&size=${size}&sortColumn=${sortColumn}&sortOrder=${sortOrder}`, { silent, area });
    }
    static stillMatterAlerts(page, size, sortColumn = "createdDate", sortOrder = "desc", silent = true, area) {
        return httpGet(`${controllerEndpoint}/dashboard/still-matter-alerts?page=${page}&size=${size}&sortColumn=${sortColumn}&sortOrder=${sortOrder}`, {
            silent,
            area,
        });
    }
}
